module.exports = __webpack_public_path__ + "static/media/txnReport.a255b77e.png";